import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
function findParticipantByTrackSid(trackSid, room) {
    if (!trackSid) {
        return undefined;
    }
    const isLocalTrack = Array.from(room.localParticipant.audioTrackPublications.values()).some((pub) => pub.trackSid === trackSid);
    if (isLocalTrack) {
        return room.localParticipant;
    }
    for (const participant of room.remoteParticipants.values()) {
        const ownsTrack = Array.from(participant.audioTrackPublications.values()).some((pub) => pub.trackSid === trackSid);
        if (ownsTrack) {
            return participant;
        }
    }
    return undefined;
}
export function transcriptionToChatMessage(textStream, room) {
    var _a;
    const trackSid = (_a = textStream.streamInfo.attributes) === null || _a === void 0 ? void 0 : _a['lk.transcribed_track_id'];
    const participantFromTrack = findParticipantByTrackSid(trackSid, room);
    const participantByIdentity = textStream.participantInfo.identity === room.localParticipant.identity
        ? room.localParticipant
        : Array.from(room.remoteParticipants.values()).find((p) => p.identity === textStream.participantInfo.identity);
    const fromParticipant = participantFromTrack !== null && participantFromTrack !== void 0 ? participantFromTrack : participantByIdentity;
    return {
        id: textStream.streamInfo.id,
        timestamp: textStream.streamInfo.timestamp,
        message: textStream.text,
        from: fromParticipant,
    };
}
